import { render, staticRenderFns } from "./groceryBagPriceSplash.vue?vue&type=template&id=27b0eef2&"
import script from "./groceryBagPriceSplash.vue?vue&type=script&lang=js&"
export * from "./groceryBagPriceSplash.vue?vue&type=script&lang=js&"
import style0 from "./groceryBagPriceSplash.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports